<template>
  <div id="data-list-list-view" class="data-list-container">
    <coaching-experience-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      :data="products"
    >
      <template slot="thead">
        <vs-th sort-key="id">{{ $t("coach.coachingExperience.ce1") }}</vs-th>
        <vs-th sort-key="name">{{ $t("coach.coachingExperience.ce2") }}</vs-th>
        <vs-th sort-key="email">{{ $t("coach.coachingExperience.ce3") }}</vs-th>
        <vs-th>{{ $t("coach.coachingExperience.ce4") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="tr.userData[0].status==='active'">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.id }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.userData[0].firstName }} {{ tr.userData[0].lastName }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.userData[0].email }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
              <vs-button @click="editData(tr.id)">{{ $t("coach.traineeList.tl5") }}</vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import CoachingExperienceSidebar from "./CoachingExperienceSidebar.vue";
import moduleDataList from "@/store/data-list/moduleDataList.js";

export default {
  components: {
    CoachingExperienceSidebar
  },
  data() {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false
      // sidebarData: 0
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    products() {

      return this.$store.state.coachingExperience.traineeList;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    }
  },
  methods: {
    /*addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },*/
    /*deleteData (id) {
        this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
      },*/
    editData(id) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      // this.sidebarData = id
      this.$store
        .dispatch("coachingExperience/setSidebarId", id)
        .then(res => {
          this.toggleDataSidebar(true);
        });
    },
    toggleDataSidebar(val = false) {
      if (val === false) {
        this.$store
          .dispatch("coachingExperience/setSidebarId", 0)
          .then(res => {});
      }
      this.addNewDataSidebar = val;
    }
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("dataList", moduleDataList);
      moduleDataList.isRegistered = true;
    }
    const query = {
      coachId: this.$store.state.AppActiveUser.usersId
    };
    this.$store
      .dispatch("coachingExperience/fetchCoach", { query })
      .then(res => {
        console.log("coach found", res);
        this.traineeCoachId = res.data[0].id;
        const coachId = this.$store.state.AppActiveUser.usersId;
        this.$store
          .dispatch("coachingExperience/fetchTrainees", { query: { coachId } })
          .then(res => {
            if (res.total > 0) {
              console.log("all trainee data", res.data);
            }
          })
          .catch(err => {});
      })
      .catch(err => {
        console.log("coach not found", err);
      });
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
